/**
 * 埋点 key 枚举
 */
export var DotKey;
(function (DotKey) {
})(DotKey || (DotKey = {}));
